// no BaseURI
      // object to store loaded and loading chunks
      // undefined = chunk not loaded, null = chunk preloaded/prefetched
      // [resolve, Promise] = chunk loading, 0 = chunk loaded
      var moduleInstalledChunks = {560: 0,};
      var moduleInstallChunk = (data) => {
    var __rspack_esm_ids = data.__rspack_esm_ids;
    var moreModules = data.__webpack_modules__;
    var __rspack_esm_runtime = data.__rspack_esm_runtime;
    // add "modules" to the modules object,
    // then flag all "ids" as loaded and fire callback
    var moduleId, chunkId, i = 0;
    for (moduleId in moreModules) {
        if (__webpack_require__.o(moreModules, moduleId)) {
            __webpack_require__.m[moduleId] = moreModules[moduleId];
        }
    }
    if (__rspack_esm_runtime) __rspack_esm_runtime(__webpack_require__);
    for (; i < __rspack_esm_ids.length; i++) {
        chunkId = __rspack_esm_ids[i];
        if (__webpack_require__.o(moduleInstalledChunks, chunkId) && moduleInstalledChunks[chunkId]) {
            moduleInstalledChunks[chunkId][0]();
        }
        moduleInstalledChunks[__rspack_esm_ids[i]] = 0;
    }
    __webpack_require__.O();
};
// no chunk on demand loading

        __webpack_require__.C = moduleInstallChunk;
        
        __webpack_require__.O.j = function(chunkId) {
            return moduleInstalledChunks[chunkId] === 0;
        }
        // no HMR
// no HMR manifest
